import { MeasurementTypes } from "./ObjectInterfaces";
import { useEffect, useState } from "react";

export const useCorrectMeasurements = (
  measurements: MeasurementTypes[],
  setNumOfMeasurements: any
) => {
  const [correctMeasurements, setCorrectMeasurements] = useState<MeasurementTypes[]>([]);

  /* Hook serving as a second filtering round, this time filtering identical measurements with the same name */
  useEffect(() => {
    let correct: MeasurementTypes[] = [];
    let displayNames: string[] = [];
    measurements.forEach((ms: MeasurementTypes) => {
      if (!displayNames.includes(ms.display_name!)) {
        displayNames.push(ms.display_name!);
        correct.push(ms);
      }
    });
    setCorrectMeasurements(correct);
    setNumOfMeasurements(correct.length);
  }, [measurements, setNumOfMeasurements]);
  return correctMeasurements;
};
